// extracted by css-extract-rspack-plugin
export default {"pageBackground":"FIPEnKuEwAF1MPI___pageBackground___"};